import { render, staticRenderFns } from "./PopupModalWrap.vue?vue&type=template&id=6c8bd83f"
import script from "./PopupModalWrap.vue?vue&type=script&lang=js"
export * from "./PopupModalWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports